module.exports = {
          srcSet: __webpack_public_path__ + "45f2f618f964f0d810770698cf9a0f52-235.png"+" 235w",
          images:[ {path: __webpack_public_path__ + "45f2f618f964f0d810770698cf9a0f52-235.png",width: 235,height: 212}],
          src: __webpack_public_path__ + "45f2f618f964f0d810770698cf9a0f52-235.png",
          toString:function(){return __webpack_public_path__ + "45f2f618f964f0d810770698cf9a0f52-235.png"},
          
          width: 235,
          height: 212
        }